import React from "react";
import { Container, LeftContentContainer, RightContentContainer } from "./MyBookingListSkeleton.styles";
import UI from "@mile-meeting/mile-ui";

const MyBookingListSkeleton: React.FC = () => {
  return (
    <Container>
      <LeftContentContainer>
        <UI.Loading.Skeleton width="200px" height="22px" />
        <UI.Loading.Skeleton width="200px" height="22px" />
        <UI.Loading.Skeleton width="200px" height="22px" />
      </LeftContentContainer>
      <RightContentContainer>
        <UI.Loading.Skeleton width="100%" height="26px" />
        <div style={{ display: "flex", gap: "20px" }}>
          <UI.Loading.Skeleton width="160px" height="30px" />
          <UI.Loading.Skeleton width="160px" height="30px" />
        </div>
      </RightContentContainer>
    </Container>
  );
};

export default React.memo(MyBookingListSkeleton);
